export const RESET = "RESET";

// -- authenticate --
export const AUTHENTICATED = "AUTHENTICATED";
export const AUTHENTICATING = "AUTHENTICATING";
export const AUTHENTICATING_COMPLETED = "AUTHENTICATING_COMPLETED";
export const AUTHENTICATING_FAILED = "AUTHENTICATING_FAILED";
export const AUTHENTICATION_RESET = "AUTHENTICATION_RESET";

// --- search ---
export const SEARCH_FETCHING = "SEARCH_FETCHING";
export const SEARCH_FETCHING_COMPLETED = "SEARCH_FETCHING_COMPLETED";
export const SEARCH_FETCHING_FAILED = "SEARCH_FETCHING_FAILED";
export const SEARCH_RESULT_LOAD = "SEARCH_RESULT_LOAD";
export const SEARCH_RESULT_RESET = "SEARCH_RESULT_RESET";
export const SEARCH_MESSAGE_LOAD = "SEARCH_MESSAGE_LOAD";
export const SEARCH_MESSAGE_RESET = "SEARCH_MESSAGE_RESET";

// --- orders-summary-email ---
export const ORDERS_SUMMARY_EMAIL_FETCHING = "ORDERS_SUMMARY_EMAIL_FETCHING";
export const ORDERS_SUMMARY_EMAIL_FETCHING_COMPLETED = "ORDERS_SUMMARY_EMAIL_FETCHING_COMPLETED";
export const ORDERS_SUMMARY_EMAIL_FETCHING_FAILED = "ORDERS_SUMMARY_EMAIL_FETCHING_FAILED";

// --- order-cancel ---
export const ORDER_CANCEL_FETCHING = "ORDER_CANCEL_FETCHING";
export const ORDER_CANCEL_FETCHING_COMPLETED = "ORDER_CANCEL_FETCHING_COMPLETED";
export const ORDER_CANCEL_FETCHING_FAILED = "ORDER_CANCEL_FETCHING_FAILED";

export const CANCEL_REASON_LIST_FETCHING = "CANCEL_REASON_LIST_FETCHING";
export const CANCEL_REASON_LIST_FETCHING_COMPLETED = "CANCEL_REASON_LIST_FETCHING_COMPLETED";
export const CANCEL_REASON_LIST_FETCHING_FAILED = "CANCEL_REASON_LIST_FETCHING_FAILED";
export const CANCEL_REASON_LIST_LOAD = "CANCEL_REASON_LIST_LOAD";
export const CANCEL_REASON_LIST_RESET = "CANCEL_REASON_LIST_RESET";

export const CANCEL_ORDER_CALCULATING = "CANCEL_ORDER_CALCULATING";
export const CANCEL_ORDER_CALCULATING_COMPLETED = "CANCEL_ORDER_CALCULATING_COMPLETED";
export const CANCEL_ORDER_CALCULATING_FAILED = "CANCEL_ORDER_CALCULATING_FAILED";
export const CANCEL_ORDER_CALCULATE_LOAD = "CANCEL_ORDER_CALCULATE_LOAD";
export const CANCEL_ORDER_CALCULATE_RESET = "CANCEL_ORDER_CALCULATE_RESET";

// --- order-return ---
export const ORDER_RETURN_FETCHING = "ORDER_RETURN_FETCHING";
export const ORDER_RETURN_FETCHING_COMPLETED = "ORDER_RETURN_FETCHING_COMPLETED";
export const ORDER_RETURN_FETCHING_FAILED = "ORDER_RETURN_FETCHING_FAILED";

export const RETURN_REASON_LIST_FETCHING = "RETURN_REASON_LIST_FETCHING";
export const RETURN_REASON_LIST_FETCHING_COMPLETED = "RETURN_REASON_LIST_FETCHING_COMPLETED";
export const RETURN_REASON_LIST_FETCHING_FAILED = "RETURN_REASON_LIST_FETCHING_FAILED";
export const RETURN_REASON_LIST_LOAD = "RETURN_REASON_LIST_LOAD";
export const RETURN_REASON_LIST_RESET = "RETURN_REASON_LIST_RESET";

export const RETURN_ORDER_CALCULATING = "RETURN_ORDER_CALCULATING";
export const RETURN_ORDER_CALCULATING_COMPLETED = "RETURN_ORDER_CALCULATING_COMPLETED";
export const RETURN_ORDER_CALCULATING_FAILED = "RETURN_ORDER_CALCULATING_FAILED";
export const RETURN_ORDER_CALCULATE_LOAD = "RETURN_ORDER_CALCULATE_LOAD";
export const RETURN_ORDER_CALCULATE_RESET = "RETURN_ORDER_CALCULATE_RESET";

// --- order-replace ---
export const ORDER_REPLACE_FETCHING = "ORDER_REPLACE_FETCHING";
export const ORDER_REPLACE_FETCHING_COMPLETED = "ORDER_REPLACE_FETCHING_COMPLETED";
export const ORDER_REPLACE_FETCHING_FAILED = "ORDER_REPLACE_FETCHING_FAILED";

export const REPLACE_REASON_LIST_FETCHING = "REPLACE_REASON_LIST_FETCHING";
export const REPLACE_REASON_LIST_FETCHING_COMPLETED = "REPLACE_REASON_LIST_FETCHING_COMPLETED";
export const REPLACE_REASON_LIST_FETCHING_FAILED = "REPLACE_REASON_LIST_FETCHING_FAILED";
export const REPLACE_REASON_LIST_LOAD = "REPLACE_REASON_LIST_LOAD";
export const REPLACE_REASON_LIST_RESET = "REPLACE_REASON_LIST_RESET";

// --- order ---
export const ORDER_FETCHING = "ORDER_FETCHING";
export const ORDER_FETCHING_COMPLETED = "ORDER_FETCHING_COMPLETED";
export const ORDER_FETCHING_FAILED = "ORDER_FETCHING_FAILED";
export const ORDER_LOAD = "ORDER_LOAD";
export const ORDER_RESET = "ORDER_RESET";

// --- order-invoice ---
export const INVOICE_FETCHING = "INVOICE_FETCHING";
export const INVOICE_FETCHING_COMPLETED = "INVOICE_FETCHING_COMPLETED";
export const INVOICE_FETCHING_FAILED = "INVOICE_FETCHING_FAILED";

export const EGIFTCARD_EMAIL_SENDING = "EGIFTCARD_EMAIL_SENDING";
export const EGIFTCARD_EMAIL_SENDING_COMPLETED = "EGIFTCARD_EMAIL_SENDING_COMPLETED";
export const EGIFTCARD_EMAIL_SENDING_FAILED = "EGIFTCARD_EMAIL_SENDING_FAILED";

// --- misc ---
export const LANGUAGE_LOAD = "LANGUAGE_LOAD";
export const LANGUAGE_RESET = "LANGUAGE_RESET";
export const STORE_LOAD = "STORE_LOAD";
export const STORE_RESET = "STORE_RESET";

export const LANGUAGE_LIST_FETCHING = "LANGUAGE_LIST_FETCHING";
export const LANGUAGE_LIST_FETCHING_COMPLETED = "LANGUAGE_LIST_FETCHING_COMPLETED";
export const LANGUAGE_LIST_FETCHING_FAILED = "LANGUAGE_LIST_FETCHING_FAILED";
export const LANGUAGE_LIST_LOAD = "LANGUAGE_LIST_LOAD";
export const LANGUAGE_LIST_RESET = "LANGUAGE_LIST_RESET";

export const STORE_LIST_FETCHING = "STORE_LIST_FETCHING";
export const STORE_LIST_FETCHING_COMPLETED = "STORE_LIST_FETCHING_COMPLETED";
export const STORE_LIST_FETCHING_FAILED = "STORE_LIST_FETCHING_FAILED";
export const STORE_LIST_LOAD = "STORE_LIST_LOAD";
export const STORE_LIST_RESET = "STORE_LIST_RESET";



// WEBPACK FOOTER //
// ./src/_constants/types.js